<template>
<v-layout column>
	<v-subheader v-if="!!model">
		{{label}}
		<v-btn icon v-if="!inputDisabled && !inputRequired" @click="deleteSub()">
			<v-icon>close</v-icon>
		</v-btn>
	</v-subheader>

	<v-flex xs3>
		<v-btn v-if="!inputDisabled && !model" @click="addSub()">
			{{'Ajouter '+ label}}
		</v-btn>
	</v-flex>

	<!-- handling error and validator -->
	<v-text-field v-model="model" class="custom-error" :rules="computedRules"></v-text-field>

	<v-layout row wrap v-if="!!model">
		<v-flex v-for="(item,index) in items" :key="item.value + index" @click="item.click && item.click(model[item.value])" :xs4="item.type !== 'sub-array'" :xs12="item.type === 'sub-array'" v-if="!item.hide || !item.hide(model[item.value], model)">
			<b-o-input v-if="item.type !== 'sub-array'" :input="item" v-model="model[item.value]" @change="update"></b-o-input>

			<sub-array-input v-if="item.type === 'sub-array'" :required="item.required" :disabled="item.disabled" :label='item.label' :rules='item.rules' @change="updateSub(item)" v-model="model[item.value]" :items="item.items"></sub-array-input>

		</v-flex>
	</v-layout>
</v-layout>
</template>

<script>
import BaseInput from './baseInput'
import SubArrayInput from './subArrayInput'
import BOInput from '../boInput'

export default {
	extends: BaseInput,
	components: { BOInput, SubArrayInput },
	props: ['items'],
	methods: {
		updateSub(item) {
			if (item.onChange) {
				item.onChange(this.model[item.value])
			}
			this.update()
		},
		deleteSub() {
			this.model = null
			this.update()
		},
		addSub() {
			this.model = {}
			this.update()
		},
		updateDisabled() {
			let itemDisabled
			for (let i = 0; i < this.items.length; i++) {
				itemDisabled = this.items[i].privateDisabled
				if (typeof itemDisabled === 'function') {
					itemDisabled = itemDisabled()
				}

				this.$set(this.items[i], 'disabled', this.inputDisabled || itemDisabled)
			}
		}
	},
	watch: {
		inputDisabled() {
			this.updateDisabled()
		}
	},
	mounted() {
		this.init()
		this.updateDisabled()
	}
}
</script>



// WEBPACK FOOTER //
// src/baseComponents/inputs/subDocInput.vue